export const testIDs = {
    common: {
        container: "common-container",
    },
    overview: {
        headings: {
            tasks: "overview-heading-tasks",
            favourites: "overview-heading-favourites",
            insights: "overview-heading-insights",
        },
        tasks: {
            certificatesExpiringIn30Days: "overview-tasks-certificatesExpiringIn30Days",
            pendingCertificateSearch: "overview-tasks-pendingCertificateSearch",
            customersMissingCertificates: "overview-tasks-customersMissingCertificates",
            addSignature: "overview-tasks-addSignature",
            defineExemption: "overview-tasks-defineExemption",
        },
        favourites: {
            addCustomer: "overview-favourites-addCustomer",
            addVendor: "overview-favourites-addVendor",
            viewAllCustomers: "overview-favourites-viewAllCustomers",
            viewAllVendors: "overview-favourites-viewAllVendors",
            addCertificate: "overview-favourites-addCertificate",
            requestCertificates: "overview-favourites-requestCertificates",
            viewAllCertificates: "overview-favourites-viewAllCertificates",
            viewAllVendorCertificates: "overview-favourites-viewAllVendorCertificates",
            reports: "overview-favourites-reports",
            retail: "overview-favourites-retail",
        },
    },
    campaign: {
        bulkRequests: {
            request: "campaign-bulkRequests-request",
            loader: "campaign-bulkRequests-loader",
            grid: "campaign-bulkRequests-grid",
            pagination: "campaign-bulkRequests-pagination",
        },
        requestDetails: {
            backButton: "campaign-requestDetails-backButton",
            searchBar: "campaign-requestDetails-searchBar",
            export: "campaign-requestDetails-export",
            grid: "campaign-requestDetails-grid",
            loader: "campaign-requestDetails-loader",
            pagination: "campaign-requestDetails-pagination",
        },
        singleRequests: {
            request: "campaign-singleRequests-request",
            searchBar: "campaign-singleRequests-searchBar",
            loader: "campaign-singleRequests-loader",
            grid: "campaign-singleRequests-grid",
            pagination: "campaign-singleRequests-pagination",
        },
    },
    customerSearch: {
        heading: "customerSearch-heading",
        reports: "customerSearch-reports",
        filtersButton: "customerSearch-filtersButton",
        searchBar: "customerSearch-searchBar",
        manageColumns: "customerSearch-manageColumns",
        moreActions: {
            button: "customerSearch-moreActions-button",
            dropdown: "customerSearch-moreActions-dropdown",
            import: "customerSearch-moreActions-import",
            export: "customerSearch-moreActions-export",
            save: "customerSearch-moreActions-save",
            delete: "customerSearch-moreActions-delete",
        },
        requestCertificates: "customerSearch-requestCertificates",
        addCustomerButton: "customerSearch-addCustomerButton",
        filtersPanel: {
            container: "customerSearch-filtersPanel-container",
            viewSavedReports: "customerSearch-filtersPanel-viewSavedReports",
            selectCompanyGroups: "customerSearch-filtersPanel-selectCompanyGroups",
            otherFilters: "customerSearch-filtersPanel-otherFilters",
        },
        grid: "customerSearch-grid",
        pagination: "customerSearch-pagination",
        loader: "customerSearch-loader",
    },
    vendorSearch: {
        heading: "vendorSearch-heading",
        reports: "vendorSearch-reports",
        filtersButton: "vendorSearch-filtersButton",
        searchBar: "vendorSearch-searchBar",
        manageColumns: "vendorSearch-manageColumns",
        moreActions: {
            button: "vendorSearch-moreActions-button",
            dropdown: "vendorSearch-moreActions-dropdown",
            import: "vendorSearch-moreActions-import",
            export: "vendorSearch-moreActions-export",
            save: "vendorSearch-moreActions-save",
        },
        addVendorButton: "vendorSearch-addVendorButton",
        filtersPanel: {
            container: "vendorSearch-filtersPanel-container",
            viewSavedReports: "vendorSearch-filtersPanel-viewSavedReports",
            otherFilters: "vendorSearch-filtersPanel-otherFilters",
        },
        grid: "vendorSearch-grid",
        pagination: "vendorSearch-pagination",
        loader: "vendorSearch-loader",
    },
    certificateSearch: {
        heading: "certificateSearch-heading",
        reports: "certificateSearch-reports",
        filtersButton: "certificateSearch-filtersButton",
        searchBar: "certificateSearch-searchBar",
        manageColumns: "certificateSearch-manageColumns",
        moreActions: {
            button: "certificateSearch-moreActions-button",
            dropdown: "certificateSearch-moreActions-dropdown",
            addCertificate: "certificateSearch-moreActions-addCertificate",
            export: "certificateSearch-moreActions-export",
            save: "certificateSearch-moreActions-save",
            exportImages: "certificateSearch-moreActions-exportImages",
            delete: "certificateSearch-moreActions-delete",
            update: "certificateSearch-moreActions-update",
            resync: "certificateSearch-moreActions-resync",
        },
        requestCertificates: "certificateSearch-requestCertificates",
        filtersPanel: {
            container: "certificateSearch-filtersPanel-container",
            viewSavedReports: "certificateSearch-filtersPanel-viewSavedReports",
            selectCompanyGroups: "certificateSearch-filtersPanel-selectCompanyGroups",
            otherFilters: "certificateSearch-filtersPanel-otherFilters",
        },
        grid: "certificateSearch-grid",
        pagination: "certificateSearch-pagination",
        loader: "certificateSearch-loader",
    },
    pendingCertificateSearch: {
        heading: "pendingCertificateSearch-heading",
        reports: "pendingCertificateSearch-reports",
        filtersButton: "pendingCertificateSearch-filtersButton",
        searchBar: "pendingCertificateSearch-searchBar",
        manageColumns: "pendingCertificateSearch-manageColumns",
        moreActions: {
            button: "pendingCertificateSearch-moreActions-button",
            dropdown: "pendingCertificateSearch-moreActions-dropdown",
            assignCertificate: "pendingCertificateSearch-moreActions-assignCertificate",
            releaseCertificates: "pendingCertificateSearch-moreActions-releaseCertificates",
            delete: "pendingCertificateSearch-moreActions-delete",
            export: "pendingCertificateSearch-moreActions-export",
            accept: "pendingCertificateSearch-moreActions-accept",
            save: "pendingCertificateSearch-moreActions-save",
            changeBucket: "pendingCertificateSearch-moreActions-changeBucket",
        },
        uploadZip: "pendingCertificateSearch-uploadZip",
        addCertificate: "pendingCertificateSearch-addCertificate",
        filtersPanel: {
            container: "pendingCertificateSearch-filtersPanel-container",
            viewSavedReports: "pendingCertificateSearch-filtersPanel-viewSavedReports",
            assignedTo: "pendingCertificateSearch-filtersPanel-assignedTo",
            escalation: "pendingCertificateSearch-filtersPanel-escalation",
            certificateImagePresent:
                "pendingCertificateSearch-filtersPanel-certificateImagePresent",
            buckets: "pendingCertificateSearch-filtersPanel-buckets",
        },
        grid: "pendingCertificateSearch-grid",
        pagination: "pendingCertificateSearch-pagination",
        loader: "pendingCertificateSearch-loader",
    },
    vendorCertificateSearch: {
        heading: "vendorCertificateSearch-heading",
        tabs: "vendorCertificateSearch-tabs",
        certificateSearch: {
            reports: "vendorCertificateSearch-certificateSearch-reports",
            filtersButton: "vendorCertificateSearch-certificateSearch-filtersButton",
            searchBar: "vendorCertificateSearch-certificateSearch-searchBar",
            manageColumns: "vendorCertificateSearch-certificateSearch-manageColumns",
            moreActions: {
                button: "vendorCertificateSearch-certificateSearch-moreActions-button",
                dropdown: "vendorCertificateSearch-certificateSearch-moreActions-dropdown",
                save: "vendorCertificateSearch-certificateSearch-moreActions-save",
                export: "vendorCertificateSearch-certificateSearch-moreActions-export",
            },
            showOnlyActiveCertificates:
                "vendorCertificateSearch-certificateSearch-showOnlyActiveCertificates",
            filtersPanel: {
                container: "vendorCertificateSearch-certificateSearch-filtersPanel-container",
                viewSavedReports:
                    "vendorCertificateSearch-certificateSearch-filtersPanel-viewSavedReports",
                otherFilters: "vendorCertificateSearch-certificateSearch-filtersPanel-otherFilters",
            },
            grid: "vendorCertificateSearch-certificateSearch-grid",
            pagination: "vendorCertificateSearch-certificateSearch-pagination",
            loader: "vendorCertificateSearch-certificateSearch-loader",
        },
        certificatePackages: {
            searchBar: "vendorCertificateSearch-certificatePackages-searchBar",
            createPackage: "vendorCertificateSearch-certificatePackages-createPackage",
            grid: "vendorCertificateSearch-certificatePackages-grid",
            pagination: "vendorCertificateSearch-certificatePackages-pagination",
            loader: "vendorCertificateSearch-certificatePackages-loader",
            noData: "vendorCertificateSearch-certificatePackages-noData",
        },
    },
    generalSettings: {
        uploadLogoButton: "upload-logo-button",
        logoFileInput: "logo-file-input",
        companyLogoImage: "company-logo-image",
        supportedFormatsText: "supported-formats-text",
        previewLogoButton: "preview-logo-button",
        logoPreviewDialog: "logo-preview-dialog",
        logoPreviewImage: "logo-preview-image",
        removeLogoButton: "remove-logo-button",
        deleteLogoDialog: "delete-logo-dialog",
        confirmDeleteLogoButton: "confirm-delete-logo-button",
        cancelDeleteLogoButton: "cancel-delete-logo-button",
    },
    templates: {
        import: {
            heading: "templates-import-heading",
            templateSelector: "templates-import-templateSelector",
            downloadButton: "templates-import-downloadButton",
            uploadArea: "templates-import-uploadArea",
            guidelines: "templates-import-guidelines",
            helpLink: "templates-import-helpLink",
            errorMessage: "templates-import-errorMessage",
            successMessage: "templates-import-successMessage",
            fileInput: "templates-import-fileInput",
            templateDescription: "templates-import-templateDescription",
        },
        customer: {
            basicTemplate: "templates-customer-basicTemplate",
            billToShipToTemplate: "templates-customer-billToShipToTemplate",
            numberChangeTemplate: "templates-customer-numberChangeTemplate",
        },
        vendor: {
            standardTemplate: "templates-vendor-standardTemplate",
            downloadLink: "templates-vendor-downloadLink",
        },
    },
    shared: {
        resources: {
            heading: "shared-resources-heading",
            description: "shared-resources-description",
            subHeading: "shared-resources-subHeading",
            tiles: {
                taxAnswers: "shared-resources-taxAnswers",
                taxLaws: "shared-resources-taxLaws",
                exemptEntities: "shared-resources-exemptEntities",
                certificateForms: "shared-resources-certificateForms",
                avalaraUniversity: "shared-resources-avalaraUniversity",
            },
            learnMore: "shared-resources-learnMore",
        },
        customerQuickSearch: "shared-customerQuickSearch",
        recordCount: "shared-recordCount",
        noData: "shared-noData",
        noAccess: "shared-noAccess",
        navigation: "shared-navigation",
        header: "shared-header",
        backButton: "back-button",
        pageInfo: "page-info",
        countryLabel: "lbl-country",
        selectCountry: "select-country",
        commentsTab: "shared-commentsTab",
        changeBucketDialog: {
            container: "shared-changeBucketDialog-container",
            select: "shared-changeBucketDialog-select",
            apply: "shared-changeBucketDialog-apply",
            cancel: "shared-changeBucketDialog-cancel"
        },
    },
    settings: {
        addInvalidReasonButton: "add-invalid-reason-button",
        editFaxEmailButton: "edit-fax-email-button",
        deleteFaxEmailButton: "delete-fax-email-button",
        userPreferences: {
            heading: "user-preferences-heading",
            description: "user-preferences-description",
            pendingNotificationCheckbox: "pending-notification-checkbox",
            savePreferencesButton: "save-preferences-button",
            backToSettingsButton: "back-to-settings-button",
        },
        manageExemptionReasons: {
            manageExemptionReasonsDialogs: {
                createUpdateExemptionReason: {
                    exemptReasonName: "exempt-reason-name",
                    exemptReasonDescription: "exempt-reason-desc",
                    entityUseCode: "entity-use-code",
                },
            },
        },
        tabs: {
            certificateRequests: {
                manageFaxEmails: {
                    addEditFaxEmailDialog: {
                        addEditFaxEmailDialog: "add-edit-fax-email-dialog",
                    },
                    deleteFaxEmailDialog: { deleteFaxEmailDialog: "delete-fx-email-dialog" },
                },
            },
        },
    },
    missingCertificatesReport: {
        filters: {
            container: "missingCertificatesReport-filters-container",
            customerCode: "missingCertificatesReport-filters-customerCode",
            customerName: "missingCertificatesReport-filters-customerName",
            customerState: "missingCertificatesReport-filters-customerState",
            exposureZone: "missingCertificatesReport-filters-exposureZone",
            customerRelationship: "missingCertificatesReport-filters-customerRelationship",
            runReportButton: "missingCertificatesReport-filters-runReportButton",
            emailReportButton: "missingCertificatesReport-filters-emailReportButton",
            exportReportButton: "missingCertificatesReport-filters-exportReportButton",
        },
        grid: "missingCertificatesReport-grid",
        pagination: "missingCertificatesReport-pagination",
        loader: "missingCertificatesReport-loader",
        recordCount: "missingCertificatesReport-recordCount",
        noData: "missingCertificatesReport-noData",
        exportDialog: {
            container: "missingCertificatesReport-exportDialog-container",
            titleInput: "missingCertificatesReport-exportDialog-titleInput",
            exportButton: "missingCertificatesReport-exportDialog-exportButton",
            cancelButton: "missingCertificatesReport-exportDialog-cancelButton",
        },
        scheduleDialog: {
            container: "missingCertificatesReport-scheduleDialog-container",
            scheduleButton: "missingCertificatesReport-scheduleDialog-scheduleButton",
            cancelButton: "missingCertificatesReport-scheduleDialog-cancelButton",
        },
    },
    review: {
        revalidate: {
            button: "review-revalidate-button",
            dialog: "revalidate-confirm-dialog",
            cancelButton: "revalidate-cancel-button",
            confirmButton: "revalidate-confirm-button",
        },
    },
    customerComments: {
        container: "customerComments-container",
        addButton: "customerComments-addButton",
        commentsList: "customerComments-commentsList",
        noComments: "customerComments-noComments",
        commentItem: "customerComments-commentItem",
        commentText: "customerComments-commentText",
        commentAuthor: "customerComments-commentAuthor",
        commentTimestamp: "customerComments-commentTimestamp",
        editButton: "customerComments-editButton",
        deleteButton: "customerComments-deleteButton",
        dialog: {
            container: "customerComments-dialog-container",
            heading: "customerComments-dialog-heading",
            textArea: "customerComments-dialog-textArea",
            saveButton: "customerComments-dialog-saveButton",
            cancelButton: "customerComments-dialog-cancelButton",
            fileInput: "customerComments-dialog-fileInput",
        },
        deleteDialog: {
            container: "customerComments-deleteDialog-container",
        },
    },
};
